import React, { Component } from "react";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import "./homepage.css";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Grid } from "semantic-ui-react";
export class HomePage extends Component {
  render() {
    return (
      <div>
        <Container maxWidth="lg" className="homePageContainer">
          <div>
            <CardContent>
              <h1 className="headingDiv">Gutenberg Project</h1>
            </CardContent>
          </div>

          <Grid columns="equal">
            <Grid.Column>
              <Card style={{ height: "150px", width: "300px" }}>
                <CardContent>
                  <Link to={`/books`}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      style={{ height: "80px", marginTop: "18px" }}
                    >
                      <span className="btn_text">FICTION</span>
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </Grid.Column>
            <Grid.Column>
              <Card style={{ height: "150px", width: "300px" }}>
                <CardContent>
                  <Link to={`/dramabooks`}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      style={{ height: "80px", marginTop: "18px" }}
                    >
                      <span className="btn_text"> DRAMA</span>
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </Grid.Column>
            <Grid.Column>
              <Card style={{ height: "150px", width: "300px" }}>
                <CardContent>
                  <Link to={`/humorbooks`}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      style={{ height: "80px", marginTop: "18px" }}
                    >
                      <span className="btn_text"> HUMOR</span>
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </Grid.Column>

            <Grid.Column>
              <Card style={{ height: "150px", width: "300px" }}>
                <CardContent>
                  <Link to={`/politcsbooks`}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      style={{ height: "80px", marginTop: "18px" }}
                    >
                      <span className="btn_text"> POLITICS</span>
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </Grid.Column>
            <Grid.Row />
            <Grid.Row />
            <Grid.Row />
            <Grid.Row className="bottomRow">
              <Grid.Column>
                <Card style={{ height: "150px", width: "300px" }}>
                  <CardContent>
                    <Link to={`/philosophybooks`}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ height: "80px", marginTop: "18px" }}
                      >
                        <span className="btn_text"> PHILOSOPHY</span>
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              </Grid.Column>
              <Grid.Column>
                <Card style={{ height: "150px", width: "300px" }}>
                  <CardContent>
                    <Link to={`/historybooks`}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ height: "80px", marginTop: "18px" }}
                      >
                        <span className="btn_text"> HISTORY</span>
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              </Grid.Column>
              <Grid.Column>
                <Card style={{ height: "150px", width: "300px" }}>
                  <CardContent>
                    <Link to={`/adventuresbooks`}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ height: "80px", marginTop: "18px" }}
                      >
                        <span className="btn_text"> ADVENTURE</span>
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default HomePage;
